import React from 'react';
import { TicketStats } from './types';
import { Ticket, Clock, CheckCircle2, MessageSquare, AlertTriangle, Zap, Users } from 'lucide-react';

interface TicketStatsProps {
  stats: TicketStats;
}

export const TicketStatsCards: React.FC<TicketStatsProps> = ({ stats }) => {
  const cards = [
    {
      label: 'Open',
      value: stats.open,
      icon: Ticket,
      color: 'text-blue-500',
      bg: 'bg-blue-500/10',
    },
    {
      label: 'In Progress',
      value: stats.in_progress,
      icon: Zap,
      color: 'text-workspace-accent',
      bg: 'bg-workspace-accent/10',
    },
    {
      label: 'Waiting on Client',
      value: stats.waiting_on_client,
      icon: Clock,
      color: 'text-amber-500',
      bg: 'bg-amber-500/10',
    },
    {
      label: 'Resolved',
      value: stats.resolved,
      icon: CheckCircle2,
      color: 'text-emerald-500',
      bg: 'bg-emerald-500/10',
    },
    {
      label: 'Urgent',
      value: stats.urgent,
      icon: AlertTriangle,
      color: 'text-red-500',
      bg: 'bg-red-500/10',
    },
    {
      label: 'Unassigned',
      value: stats.unassigned,
      icon: Users,
      color: 'text-orange-500',
      bg: 'bg-orange-500/10',
    },
    {
      label: 'Avg Response',
      value: stats.avg_first_response_hours !== null
        ? `${stats.avg_first_response_hours}h`
        : '—',
      icon: MessageSquare,
      color: 'text-violet-500',
      bg: 'bg-violet-500/10',
      isText: true,
    },
  ];

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-7 gap-4 mb-8">
      {cards.map(({ label, value, icon: Icon, color, bg, isText }) => (
        <div key={label} className="p-4 rounded-2xl bg-card border border-border shadow-sm">
          <div className="flex items-center justify-between mb-2">
            <span className="text-xs font-medium text-muted-foreground uppercase tracking-wider leading-tight">{label}</span>
            <div className={`w-8 h-8 rounded-lg ${bg} flex items-center justify-center flex-shrink-0`}>
              <Icon className={`w-4 h-4 ${color}`} />
            </div>
          </div>
          <div className={`font-bold ${isText ? 'text-xl' : 'text-2xl'} text-foreground`}>{value}</div>
        </div>
      ))}
    </div>
  );
};
